export enum NombreProducto {
  ProductoArrendamientos = 'Arrendamiento',
  ProductoRenovacionArrendamientos = 'Arrendamiento',
  ProductoAutos = 'Autos',
  ProductoAutosCotizador = 'Autos',
  ProductoDeportistas = 'Deportistas',
  ProductoMascotas = 'Mascotas',
  ProductoSaludDigital = 'Salud',
  ProductoPac = 'Plan complementario de salud',
  ProductoProteccionDigitalPersonas = 'Protección digital personas',
  ProductoRenovacionSaludDigital = 'Salud',
  ProductoRecargaSaludDigital = 'Salud',
  ProductoSoat = 'Soat',
  ProductoSoatRauc = 'Soat',
  ProductoViajesInternacional = 'Viajes',
  ProductoViajesNacional = 'Viajes',
  ProductoViajesMov = 'Viajes',
  ProductoVida = 'Vida',
  MOTOSDIGITAL = 'Motos',
  AUTOSDIGITAL = 'Autos digital',
  ARRENDAMIENTODIGITAL = 'Arrendamiento digital',
  VIAJESDIGITAL = 'Viajes digital',
}
